import { JSEncrypt } from "encryptlong";
import CryptoJS from "crypto-js/crypto-js";
import { Base64 } from "js-base64";
import axios from "axios";
import i18n from "../i18n/index.js";
import BigNumber from "bignumber.js";
import momentTz from "moment-timezone";
class Precision {
  // 乘法
  times(num1, num2, ...others) {
    if (others.length > 0) {
      return this.times(this.times(num1, num2), ...others);
    }
    num1 = num1 || 0;
    num2 = num2 || 0;
    const num1Changed = this.float2Fixed(num1);
    const num2Changed = this.float2Fixed(num2);
    // 把两个数的小数位数相加
    const baseNum = this.digitLength(num1) + this.digitLength(num2);
    const leftValue = num1Changed * num2Changed;
    // this.checkBoundary(leftValue)
    return leftValue / Math.pow(10, baseNum);
  }
  // 精确加法
  plus(num1, num2, ...others) {
    if (others.length > 0) {
      return this.plus(this.plus(num1, num2), ...others);
    }
    const baseNum = Math.pow(
      10,
      Math.max(this.digitLength(num1), this.digitLength(num2))
    );
    return (this.times(num1, baseNum) + this.times(num2, baseNum)) / baseNum;
  }
  // 精确减法
  minus(num1, num2, ...others) {
    if (others.length > 0) {
      return this.minus(this.minus(num1, num2), ...others);
    }
    const baseNum = Math.pow(
      10,
      Math.max(this.digitLength(num1), this.digitLength(num2))
    );
    return (this.times(num1, baseNum) - this.times(num2, baseNum)) / baseNum;
  }
  // 精确除法
  divide(num1, num2, ...others) {
    if (others.length > 0) {
      return this.divide(this.divide(num1, num2), ...others);
    }
    const num1Change = this.float2Fixed(num1);
    const num2Change = this.float2Fixed(num2);
    return this.times(
      num1Change / num2Change,
      Math.pow(10, this.digitLength(num2) - this.digitLength(num1))
    );
  }
  // 四舍五入，且保留小数
  round(num, ratio) {
    const base = Math.pow(10, ratio);
    return this.divide(Math.round(this.times(num, base)), base);
  }
  // 把小数转成整数，支持科学计数法。如果是小数则放大成整数
  float2Fixed(num) {
    if (!~num.toString().indexOf("e")) {
      return Number(num.toString().replace(".", ""));
    }
    const dlen = this.digitLength(num);
    return dlen > 0 ? num * Math.pow(10, dlen) : num;
  }
  // 获取当前数小数位的长度(处理科学计数法，本质上处理e-n的情况)
  digitLength(num) {
    const eSplit = num.toString().split(/[eE]/);
    const len = (eSplit[0].split(".")[1] || "").length - (+eSplit[1] || 0);
    return len > 0 ? len : 0;
  }
  // 将科学计算法转换成普通数字
  convertNum(inputNumber) {
    if (isNaN(inputNumber)) {
      return inputNumber;
    }
    inputNumber = "" + inputNumber;
    inputNumber = parseFloat(inputNumber);
    let eformat = inputNumber.toExponential(); // 转换为标准的科学计数法形式（字符串）
    let tmpArray = eformat.match(/\d(?:\.(\d*))?e([+-]\d+)/); // 分离出小数值和指数值
    let number = inputNumber.toFixed(
      Math.max(0, (tmpArray[1] || "").length - tmpArray[2])
    );
    return number;
  }
  //  检测数字是否越界，如果越界给出提示
  checkBoundary(num) {
    if (num > Number.MAX_SAFE_INTEGER || num < Number.MIN_SAFE_INTEGER) {
      console.log(
        `${num} is beyond boundary when transfer to integer, the results may not be accurate`
      );
    }
  }
}

function withDefault(value, defaultValue) {
  return value === null || value === undefined ? defaultValue : value;
}

const Utils = {
  precision: new Precision(),
  withDefault,
  getLang: () => {
    switch (i18n.locale) {
      case "zh_CN":
        return "zh-CN";
      case "zh_TW":
        return "zh-TW";
      case "en_US":
        return "en-US";
      case "pt_BR":
        return "pt";
      case "ja_JP":
        return "ja";
      default:
        return "zh-CN";
    }
  },
  formartNumWithSub(val) {
    if (isNaN(val)) return 0;
    let subIndx = 0;
    const [integer, decimal] = val.toString().split(".");
    const arr = decimal.split("");
    try {
      arr.forEach((item, index) => {
        if (item != "0") {
          subIndx = index;
          throw new Error("LoopInterrupt");
        }
      });
    } catch (error) {
      //
    }
    const decimals = decimal.slice(subIndx);
    return `${integer}.0<sub>${subIndx}</sub>${decimals}`;
  },
  formatPrice(price, allPriceObj) {
    const symbolObj = {
      CNY: "￥",
      USD: "$",
      TWD: "NT$",
      JPY: "¥",
      KRW: "₩",
      BRL: "R$",
      VND: "₫",
    };
    const selectType = localStorage.getItem("selectType") || "USD";
    const exchangeRatePrice = allPriceObj;
    return (
      symbolObj[selectType] +
      new BigNumber(price).multipliedBy(exchangeRatePrice).toFixed()
    );
  },
  getMathValue(value) {
    const val = new BigNumber(value).isLessThan("0.000001");
    if (val) {
      return value;
    }
    return Number(value);
  },
  getOssData() {
    const url =
      process.env.NODE_ENV == "production"
        ? "https://biking-pod.oss-cn-hongkong.aliyuncs.com/biking/domain.json"
        : process.env.NODE_ENV == "simulation"
        ? "https://biking-pre.oss-cn-hongkong.aliyuncs.com/biking/domain.json"
        : "https://biking-pod.oss-cn-hongkong.aliyuncs.com/biking/domain.json";
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url,
        dataType: "json",
        crossDomain: true,
        cache: false,
        headers: {
          "Cache-Control": "no-cache",
        },
      })
        .then((res) => {
          localStorage.setItem("simulatedContract", res.data.simulatedContract);
          localStorage.setItem("imLink", res.data.imLink);
          resolve(res.data.simulatedContract);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getOssDataAll() {
    console.info(process.env.NODE_ENV, "simulationsimulationsimulation");
    const url =
      process.env.NODE_ENV == "production"
        ? "https://biking-pre.oss-cn-hongkong.aliyuncs.com/biking/domain.json"
        : process.env.NODE_ENV == "simulation"
        ? "https://biking-pre.oss-cn-hongkong.aliyuncs.com/biking/domain.json"
        : "https://biking-pre.oss-cn-hongkong.aliyuncs.com/biking/domain.json";
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url,
        dataType: "json",
        crossDomain: true,
        cache: false,
        headers: {
          "Cache-Control": "no-cache",
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getZendeskData: (url) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url,
        dataType: "json",
        crossDomain: true,
        cache: false,
        headers: {
          "api-key": "6uq12v0_nMBTGXFmQA9eBky-10-Fc5_oq2eMamB1gUU",
          accept: "application/json",
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDexTransData: (chain, chainId, pairAddress, baseAddress, quoteAddress) => {
    let data = "";
    if (chainId == 56) {
      data = JSON.stringify({
        query:
          '{\n  ethereum(network: bsc) {\n    dexTrades(\n      options: {limit: 20, desc: "timeInterval.second"}\n      date: {since: "2024-02-05"}\n      exchangeName: {is: "Pancake v2"}\n      baseCurrency: {is: "' +
          quoteAddress +
          '"}\n      quoteCurrency: {is: "' +
          baseAddress +
          '"}\n      smartContractAddress: {is: "' +
          pairAddress +
          '"}\n    ) {\n      count\n      tradeAmount(in: USD)\n      timeInterval {\n        second(count: 10)\n      }\n      transaction {\n        hash\n      }\n      block {\n        height\n        timestamp {\n          iso8601\n        }\n      }\n      tradeIndex\n      buyAmount\n      buyAmountInUsd: buyAmount(in: USD)\n      buyCurrency {\n        symbol\n        address\n      }\n      sellAmount\n      sellAmountInUsd: sellAmount(in: USD)\n      sellCurrency {\n        symbol\n        address\n        name\n      }\n      sellAmountInUsd: sellAmount(in: USD)\n      tradeAmount(in: USD)\n      transaction {\n        hash\n      }\n      quotePrice(calculate: maximum)\n      quoteCurrency {\n        name\n      }\n      quoteAmount(calculate: maximum)\n      price(calculate: maximum)\n      side\n    }\n  }\n}\n',
        variables: "{}",
      });
    } else {
      // if (chain == 'ethereum')
      data = JSON.stringify({
        query:
          'query ($network: EthereumNetwork!, $limit: Int!, $offset: Int!, $from: ISO8601DateTime, $till: ISO8601DateTime) {\n  ethereum(network: $network) {\n    dexTrades(\n      options: {desc: ["block.height", "tradeIndex"], limit: $limit, offset: $offset}\n      date: {since: $from, till: $till}\n      smartContractAddress: {is: "' +
          pairAddress +
          '"}\n    ) {\n      block {\n        timestamp {\n          iso8601\n        }\n        height\n      }\n      tradeIndex\n      exchange {\n        fullName\n      }\n      smartContract {\n        address {\n          address\n          annotation\n        }\n      }\n      buyAmount\n      buy_amount_usd: buyAmount(in: USD)\n      buyCurrency {\n        address\n        symbol\n        decimals\n        name\n        tokenId\n        tokenType\n      }\n      sellAmount\n      sell_amount_usd: sellAmount(in: ETH)\n      sellCurrency {\n        address\n        symbol\n        decimals\n        name\n        properties\n        tokenId\n      }\n      transaction {\n        hash\n      }\n    }\n  }\n}\n',
        variables:
          '{\n  "limit": 20,\n  "offset": 0,\n  "network": "' +
          chain +
          '",\n  "dateFormat": "%m-%d"\n}',
      });
    }
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "https://graphql.bitquery.io",
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": "BQYLOTs0lZWKLXvRAKsaIIh0vaAagrwm",
        },
        data: data,
      })
        .then((res) => {
          resolve(res.data.data.ethereum.dexTrades);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getVideoFlash: (url) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url,
        responseType: 'blob',
        crossDomain: true,
        cache: false,
        headers: {
          'Accept': 'video/mp4, video/webm, video/ogg, */*',
          'Cache-Control': 'no-cache'
        }
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  handleData: () => {
    const datas = Utils.handleBase(process.env.wo.toString());
    const par = "!";
    const data = datas.slice(7, 14) + datas.slice(19);
    return data + par;
  },
  isPasswordNewReGy(pwd) {
    var desc = "";
    var c =
      /^(?![A-Za-z0-9]+$)(?![a-z0-9\W]+$)(?![A-Za-z\W]+$)(?![A-Z0-9\W]+$)[a-zA-Z0-9\W]{0,99}$/;
    var c2 = /^(?=.*[A-Z].*)(?=.*[a-z].*).*$/;
    var c3 = /^(?=.*[0-9].*).*$/;
    var c4 =
      /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;

    const reg =
      /^(?![a-z0-9\W]+$)(?![A-Za-z\W]+$)(?![A-Z0-9\W]+$)[a-zA-Z0-9\W]{8,32}$/;
    if (reg.test(pwd)) {
      return "";
    }
    return {
      success: false,
      text: "密码格式错误，密码必须是8-32位，同时包含大小写字母和数字。",
    };
    // let zmlist = [c2.test(pwd), c3.test(pwd), c4.test(pwd)];
    //     zmlist = zmlist.filter((v) => v);
    // var msgObj = {
    //     leng:{success:false,text:'8-32位'},
    //     lg:{success:zmlist.length >= 2,text:'必须包含大小写英文、数字、特殊字符，其中至少2种'},
    // };
    // if (pwd.length < 8 || pwd.length > 32) {msgObj.leng.success = false;}else{msgObj.leng.success = true;}
    // if (msgObj.leng.success && msgObj.lg.success) {
    //   msgObj= "";
    // }
    // return msgObj;
  },
  // 获取小数位数
  retainDecimals(value, obj = {}) {
    if (!value) return 0;
    value = value.toString();
    if (~value.indexOf("e")) {
      return 0;
    }
    let decimals = "";
    if (value.indexOf(".") > 0 && obj.decimal !== 0) {
      let decimalsRe = new RegExp("[.]{1}[0-9]{0," + (obj.decimal || 8) + "}");
      let decimalsExec = decimalsRe.exec(value);
      decimalsExec && (decimals = decimalsExec[0]);
    }
    let v = 0;
    let re = new RegExp("^-?[0-9]{1}[0-9]{0," + (obj.integer - 1 || 8) + "}");
    v = re.exec(value);
    let n = "";
    if (v) {
      n = v[0];
    }
    return n + decimals;
  },
  // 数字加逗号
  numberFormat(num) {
    if (num) {
      let [num1, num2] = num.toString().split(".");
      num1 = num1
        .split("")
        .reverse()
        .map((item, index) => {
          return index % 3 || !index || item === "-" || item === "+"
            ? item
            : item + ",";
        })
        .reverse()
        .join("");
      num2 ? (num = num1 + "." + num2) : (num = num1);
    }
    return num;
  },
  // 补充0
  splitFormat(num, fractionDigits, len) {
    if (isNaN(num)) return num;
    if (num) {
      if (num === "0") {
        return num;
      }
      let digit = num.toString().split(".");
      if (fractionDigits === 0) {
        return digit[0];
      }
      if (digit.length > 1) {
        if (fractionDigits === 0) {
          return digit[0];
        } else if (digit[1].length < fractionDigits) {
          let digitResult = "";
          for (let i = 0; i < fractionDigits - digit[1].length; i++) {
            digitResult += "0";
          }
          return num + digitResult;
        } else {
          let digitResult = digit[1].substring(0, len || fractionDigits);
          return digit[0] + "." + digitResult;
        }
      } else {
        let digitResult = ".";
        for (let i = 0; i < fractionDigits; i++) {
          digitResult += "0";
        }
        return num + digitResult;
      }
    } else {
      return num;
    }
  },
  // 位数不够补0
  addZero(num, len) {
    if (isNaN(num)) return 0;
    let str = String(num);
    return String(str).replace(
      new RegExp(`^(\\-?)(\\d+)(\\.\\d{1,${len}})?`),
      (n, a, b, c) => {
        let str = a + b; // .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        if (!len) {
          return str;
        }
        if (c) {
          str += c + repeat("0", len - c.length);
        } else {
          str += "." + repeat("0", len);
        }
        return str;
      }
    );
  },
  // 数字加逗号
  addCommom(num, len) {
    if (isNaN(num) || !num) return num;
    num = String(num);
    if (!isNaN(len)) {
      if (len === 0) {
        num = num.split(".")[0];
      }
      return num.replace(/(\d+)(\.\d+)?/, (a, b, c) => {
        return (
          b.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") +
          (c ? c.slice(0, len + 1) : "")
        );
      });
    } else {
      return num.replace(/^\d+/, (a) => {
        return a.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
      });
    }
  },
  // 获取时间年月日 时分秒
  timeFormat(time, type) {
    let date = getTimeZone(time);
    if (!type) return getYMD(date) + " " + getHMS(date);
    switch (type) {
      case "HMS":
        return getHMS(date);
      case "YMD":
        return getYMD(date);
    }
  },
  cssProperty(attr) {
    var prefix = ["O", "ms", "Moz", "Webkit"];
    var len = prefix.length;
    var style = document.createElement("i").style;
    if (attr in style) {
      return true;
    }
    attr = attr.replace(/^[a-z]/, function (val) {
      return val.toUpperCase();
    });
    while (len--) {
      if (prefix[len] + attr in style) {
        return true;
      }
    }
    return false;
  },

  gettopLocation() {
    const location = window.location;
    const origin = location.origin;
    const _host = location.host;
    const protocol = location.protocol;

    let filter = origin;
    if (origin.indexOf("8548") > -1) {
      filter = "http://47.242.246.144:8547";
    } else if (origin.indexOf("141") > -1) {
      filter = "http://47.242.153.141:8100";
    } else if (origin.indexOf("160") > -1) {
      filter = "http://47.242.178.160:8100";
    } else if (origin.indexOf("hjmusib") > -1) {
      filter = "https://futures.hjmusib.cn";
    } else if (origin.indexOf("localhost") > -1) {
      filter = "http://47.242.178.160:8100";
    } else {
      if (_host.indexOf("www.") > -1) {
        var _url = _host.substring(_host.indexOf("."));
        filter = `${protocol}//futures${_url}`;
      } else {
        filter = protocol + "//futures." + _host;
      }
    }
    return filter;
  },
  moneyformat(money, digit) {
    if (typeof digit == "undefined") {
      digit = 4;
    }
    money = Utils.editE(money);
    if (
      money != null &&
      money.toString().split(".") != null &&
      money.toString().split(".")[1] != null
    ) {
      var end = money.toString().split(".")[1];
      if (end.length > digit) {
        end = end.substring(0, digit);
      } else if (end.length < digit) {
        for (var i = 0; i <= digit - end.length; i++) {
          end += "0";
        }
      }
      money = money.toString().split(".")[0] + "." + end;
    } else {
      money = money.toString() + ".";
      for (var i = 0; i < digit; i++) {
        money += "0";
      }
    }
    if (digit == 0) {
      money = money.substring(0, money.length - 1);
    }
    return money;
  },

  editE: function (num) {
    if (!num) return num;
    num = num.toString();
    if (num.indexOf("e") === -1) {
      return num;
    }
    var reg = /(?:(\d)+(?:.(\d+))?)[e]{1}-(\d)/.exec(num);
    if (!reg) {
      return num;
    }
    var v = num;
    if (reg[3] === "7") {
      v = "0.000000" + (reg[2] ? reg[1] + reg[2] : reg[1]);
    } else {
      v = "0.0000000" + reg[1];
    }
    return v;
  },
  EncryptoWithParams: (text) => {
    var key = CryptoJS.enc.Utf8.parse(Utils.handleData());
    var srcs = CryptoJS.enc.Utf8.parse(text);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  },
  DecryptoWithParams: (text) => {
    var key = CryptoJS.enc.Utf8.parse(Utils.handleData());
    var decrypt = CryptoJS.AES.decrypt(text, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },
  Encrypt: function (text) {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(
      "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDNXv9BBSTIntn0nd+Wfjyg dVLsn0nLmq5P8KbMNWVmdZah1nGw8Mxu1R5PEKguOSgmQLJvqb3Aii0lip3l o0imF15RaFj8tieQfSbywFIFruV8CxaYgH2qAS3pF5ACVSNWiHsjbVUp+Qni PyaP/WaBKQKNYeqVVAIjS7ofbceVtwIDAQAB"
    );
    return encrypt.encrypt(text);
  },
  os() {
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isIpad = /(?:iPad|PlayBook)/.test(ua),
      isTablet =
        /(?:iPad|PlayBook)/.test(ua) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = (/(?:iPhone)/.test(ua) && !isTablet) || isIpad,
      isPc = !isPhone && !isAndroid && !isSymbian;
    return {
      isTablet: isTablet,
      isPhone:
        isPhone ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1),
      isAndroid: isAndroid,
      isPc: isPc,
    };
  },
  isMobile() {
    const isMobiles =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Opera Mobi|Windows CE|Symbian|Windows Phone|POLARIS|lgtelecom|nokia|SonyEricsson|LG|SAMSUNG|Samsung/i.test(
        navigator.userAgent
      ) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    return isMobiles;
  },
  countDownTime(startTime, endTime) {
    const bjTime = momentTz().tz("Asia/Shanghai").format("YYYY-MM-DD HH:mm:ss");
    const currentTime = momentTz(bjTime).tz("Asia/Shanghai").valueOf(); //获取当前时间
    const _startTime = momentTz(startTime).tz("Asia/Shanghai").valueOf();
    const _endTime = momentTz(endTime).tz("Asia/Shanghai").valueOf();
    console.log(
      currentTime,
      _startTime,
      _endTime,
      "countDownTimecountDownTimecountDownTime"
    );
    if (_startTime && _endTime) {
      if (currentTime > _startTime && currentTime < _endTime)
        return { active: true, noStart: false, end: false };
      if (currentTime < _startTime && currentTime < _endTime)
        return { noStart: true, active: false, end: false };
      if (currentTime > _startTime && currentTime > _endTime)
        return { active: false, noStart: false, end: true };
    } else {
      return { active: false, noStart: false, end: false };
    }
    // return {active, _startTime, _endTime }
  },
  handleBase(text) {
    return Base64.decode(text);
  },
  initYidun(initCallback, verifyCallback) {
    let captchaIns = null;
    initNECaptchaWithFallback(
      {
        element: "#wycaptcha",
        captchaId: "bcc800a8565847e4987cb08eb5de05bc",
        width: "320px",
        mode: "popup",
        apiVersion: 2,
        popupStyles: {
          position: "fixed",
          top: "20%",
        },
        lang: Utils.getLang(),
        onVerify: (err, data) => {
          if (err) return; // 当验证失败时，内部会自动refresh方法，无需手动再调用一次
          const result1 = { ydValidate: data.validate };
          verifyCallback(result1);
        },
        onClose: () => {
          captchaIns.refresh();
        },
      },
      (instance) => {
        captchaIns = instance;
        initCallback(instance);
      },
      function onerror(err) {
        console.warn(err);
      }
    );
  },
};
// 字符串复制
function repeat(target, n) {
  var s = "";
  while (n > 0) {
    if (n % 2 === 1) {
      s += target;
    }
    if (n === 1) {
      break;
    }
    target += target;
    n = n >> 1;
  }
  return s;
}
function singleFormat(str) {
  return str.toString().length === 1 ? "0" + str : str;
}

function getYMD(time) {
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let date = time.getDate();
  return year + "-" + singleFormat(month) + "-" + singleFormat(date);
}

function getHMS(time) {
  let hours = time.getHours();
  let minutes = time.getMinutes();
  let seconds = time.getSeconds();
  return (
    singleFormat(hours) +
    ":" +
    singleFormat(minutes) +
    ":" +
    singleFormat(seconds)
  );
}
function getTimeZone(time) {
  let GTM_8 = 480; // -480
  let date = new Date(time);
  let subMin = date.getTimezoneOffset() + GTM_8;
  date.setMinutes(date.getMinutes() + subMin);
  return date;
}

export default Utils;



// WEBPACK FOOTER //
// ./src/common/util.js